<template>
    <div class="widget index-ad-block" v-bind:style="bgStyle">
        <icon-close class="index-ad-block__close-btn" v-if="showCloseBtn" v-on:click.native="closeBanner" />
        <div class="major-grid">
            <div style="position: relative; z-index: 10;">
                <!--<ui-link v-bind:to="{ name: 'advertise' }" class="index-ad-block__sponsored-tag">-->
                <!--    {{ $t('ads.sponsored') }}-->
                <!--</ui-link>-->
                <div class="index-ad-block__header" v-html="$t(`ads.${service}.title`)" />
                <div class="index-ad-block__description" v-html="$t(`ads.${service}.description`)" />
            </div>
            <div>
                <img v-bind:src="bannerUrl" class="index-ad-img" />
                <img class="index-ad-img--grid" v-bind:src="maskGridUrl" v-bind:alt="service" />
            </div>
        </div>
        <a v-bind:href="$t(`ads.${service}.link`)" target="_blank" class="index-ad-button">{{ $t(`ads.${service}.button`) }}</a>
    </div>
</template>

<script>
import bannerUrl from '@img/advertise/thefund/building.png'; // eslint-disable-line
import maskGridUrl from '@img/advertise/mask-grid.png';
import IconClose from '@primer/octicons/build/svg/x-24.svg?inline';

export default {
    props: {
        showCloseBtn: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            maskGridUrl,
            service: 'thefund',
            bannerUrl,
        };
    },

    methods: {
        closeBanner() {
            this.$store.dispatch('closeAd');
        },
    },

    components: {
        // bannerUrl,
        IconClose,
    },
};
</script>

<style lang="scss">
.index-ad-block {
    //border: none!important;
    //border: 1px solid #1E8DFE !important; // default var(--header-border-bottom-color)
    background: linear-gradient(90deg, #1D1D1D 0%, #2E2E2E 100%);
    //font-family: Nunito, Rubik, Roboto, Ubuntu, Arial, sans-serif;
    padding: 10px 20px 16px 20px;
    color: white;
    position: relative;
    min-width: 0;
    box-sizing: border-box;

    &__sponsored-tag {
        font-size: 12px;
        font-weight: 500;
        color: white;
        background-color: hsla(0, 0%, 100%, .14);
        display: inline-block;
        border-radius: 5px;
        padding: 2px 6px;
        margin-bottom: 7px;
        text-transform: uppercase;

        &:hover {
            background-color: hsla(0, 0%, 100%, .25);
            text-decoration: none;
        }
    }

    &__header {
        text-transform: uppercase;
        font-weight: 500;
        font-size: 22px;
        margin-top: 8px;
        margin-bottom: 4px;

        svg {
            width: 22px;
            height: 23px;
            fill: white;
            color: white;
            margin-bottom: -3px;
        }
    }

    &__description {
        max-width: 210px;
        opacity: .9;
        b {
            font-weight: 500;
        }
    }

    &__close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        color: white;
        fill: white;

        width: 20px;
        height: 20px;
        background-color: var(--body-light-muted-color);
        border-radius: 15px;
        z-index: 100;
        backdrop-filter: blur(5px);
    }
}

.index-ad-grid {
    display: grid;
    grid-template-columns: 220px auto;
}

@media screen and (max-width: 1170px) {
    .index-ad-grid {
        grid-template-columns: 400px auto;
        margin-top: 10px;
    }
}

.index-ad-button {
    display: block;
    text-align: center;
    width: 100%;
    background: #fff;
    padding: 10px 0;
    border-radius: 8px;
    font-size: 16px;
    margin-top: 15px;
    text-transform: uppercase;
    color: #1D1D1D;
    font-weight: 500;
    font-family: Rubik, Roboto, Ubuntu, Arial, sans-serif;
    cursor: pointer;
    position: relative;
    z-index: 10;

    &:hover {
        background: #f3f3f3;
        text-decoration: none;
    }
}

.index-ad-img {
    position: absolute;
    width: 162px;
    height: auto;
    bottom: 3px;
    right: -6px;
    z-index: 8;

    &--grid {
        position: absolute;
        width: auto;
        height: 200px;
        top: 0;
        right: 0;
        z-index: 8;
    }
}

@media screen and (max-width: 1170px) {
    .major-img {
        width: 180px;
    }
}

.revo-3d-logo {
    position: absolute;
    width: 94px;
    height: 94px;
    top: 10px;
    right: 35px;
}

.revo-blockchains-image {
    position: absolute;
    width: 126px;
    bottom: 8px;
    right: 22px;
}
</style>
